import React from 'react';
export function SocialProofBar() {
  return <div className="w-full bg-[#F0F4FF] py-6 border-y border-blue-100" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="grid grid-cols-2 md:flex md:flex-row items-center justify-center gap-4 md:gap-0 divide-transparent md:divide-gold/30 md:divide-x-2" data-id="element-191">
          <div className="flex items-center justify-center px-4 text-center" data-id="element-192">
            <span className="font-inter font-medium text-navy text-sm sm:text-base" data-id="element-193">
              ⭐⭐⭐⭐⭐ 4.9/5 estrellas
            </span>
          </div>

          <div className="flex items-center justify-center px-4 text-center" data-id="element-194">
            <span className="font-inter font-medium text-navy text-sm sm:text-base" data-id="element-195">
              👩‍🏫 +500 Docentes ya lo usan
            </span>
          </div>

          <div className="flex items-center justify-center px-4 text-center" data-id="element-196">
            <span className="font-inter font-medium text-navy text-sm sm:text-base" data-id="element-197">
              🇦🇷 Hecho para Argentina
            </span>
          </div>

          <div className="flex items-center justify-center px-4 text-center" data-id="element-198">
            <span className="font-inter font-medium text-navy text-sm sm:text-base" data-id="element-199">
              ⏱️ Ahorrá 5-10hs por semana
            </span>
          </div>
        </div>
      </div>
    </div>;
}